import { createContext } from 'react';

const WidthStoreContext = createContext();

export default WidthStoreContext;